const isDisabledRoute = (disabledRoutes: string[] = [], pathname: string = "") =>
  disabledRoutes.some((route) => pathname.startsWith(route));

export default isDisabledRoute;
